import { useState, useEffect } from "react"
import { motion, useScroll, useTransform } from "framer-motion"
import { Menu, X } from "lucide-react"
import { Link, useNavigate } from "react-router-dom"

export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const navigate = useNavigate()
  
  const { scrollY } = useScroll()
  const navBackground = useTransform(scrollY, [0, 50], ["rgba(255, 255, 255, 0)", "rgba(255, 255, 255, 0.8)"])
  const navBackdrop = useTransform(scrollY, [0, 50], ["blur(0px)", "blur(12px)"])
  const navBorder = useTransform(scrollY, [0, 50], ["rgba(229, 231, 235, 0)", "rgba(229, 231, 235, 0.5)"])

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const handleGetStarted = () => {
    console.log('🚀 Get Started clicked - navigating to /auth/register')
    navigate('/auth/register')
  }

  const handleLogin = () => {
    console.log('🔐 Login clicked - navigating to /auth/login')
    navigate('/auth/login')
  }

  return (
    <motion.header
      style={{
        backgroundColor: navBackground,
        backdropFilter: navBackdrop,
        borderBottom: `1px solid`,
        borderColor: navBorder,
      }}
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white font-bold text-2xl shadow-lg group-hover:shadow-blue-500/25 transition-all duration-300">
              Z
            </div>
            <span className="font-bold text-xl tracking-tight">Z App</span>
          </Link>

          {/* CTA Buttons Only */}
          <div className="hidden md:flex items-center gap-4">
            <button 
              onClick={handleLogin}
              className="text-sm font-medium hover:text-blue-500 transition-colors"
            >
              Log in
            </button>
            <button 
              onClick={handleGetStarted}
              className="bg-blue-500 hover:bg-blue-600 text-white rounded-full px-6 py-2.5 shadow-lg shadow-blue-500/20 hover:shadow-blue-500/40 transition-all duration-300 hover:-translate-y-0.5 font-semibold"
            >
              Get Started Free
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2" 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden absolute top-20 left-0 right-0 bg-white border-b border-gray-200 p-4 shadow-xl"
        >
          <nav className="flex flex-col gap-4">
            <div className="h-px bg-gray-200 my-2" />
            <button 
              onClick={handleLogin}
              className="text-base font-medium p-2 hover:bg-gray-100 rounded-lg text-left"
            >
              Log in
            </button>
            <button 
              onClick={handleGetStarted}
              className="w-full bg-blue-500 text-white rounded-full py-3 font-semibold hover:bg-blue-600 transition-colors"
            >
              Get Started Free
            </button>
          </nav>
        </motion.div>
      )}
    </motion.header>
  )
}
